<div class="waiter_header">
    <div class="header_user w-100">
        <div>
            <app-change-language class="language_change " [ShowFullName]="true"></app-change-language>
        </div>
        <div class="user_info">
            <label class=" user_lbl_name"> {{firstNameLastName}} </label>
            <label class=" user_lbl_email">{{email}}</label>
        </div>
        <div>
            <img src="{{imagePath}}" class="user_image" alt="" style="cursor: pointer;"
                (click)="menu_user.toggle($event)">
        </div>
    </div>
    <p-menu #menu_user class="edit-menu" id="user_menu" [popup]="true" [model]="items"></p-menu>
</div>
